/* eslint-disable no-unused-vars */
import { errorOfType, errorTypes } from '../../utilities/Errors'

const subCollections = ['features', 'colours']

const getItemByItemKey = firestore => async ({ itemKey }) => {
	if (!itemKey) {
		throw errorOfType(errorTypes.KEYNOTSPECIFIED, 'getItemByItemKey')
	}
	try {
		const itemDocRef = firestore.collection('items').doc(itemKey)
		const itemDocSnap = await itemDocRef.get()

		if (!itemDocSnap.exists) {
			return Promise.reject(errorOfType(errorTypes.NOTFOUND, { itemKey }))
		}
		const item = itemDocSnap.data()
		if (item.deleted) {
			return Promise.reject(errorOfType(errorTypes.NOTFOUND, { itemKey, reason: 'deleted' }))
		}

		//	Retrieve all the sub-collections
		const subCollectionsDocs = await Promise.all(subCollections.map(async (subColl) => {
			const querySnap = await itemDocRef.collection(subColl).get().catch((error) => {
				console.error('ERROR', error)
			})
			return (querySnap && querySnap.docs.map(doc => doc.data())) || []
		}))

		subCollectionsDocs.forEach((subCollectionDoc, i) => {
			item[subCollections[i]] = subCollectionDoc
			item[subCollections[i]] = item[subCollections[i]].sort((a, b) => a.order - b.order)
		})

		return { item }
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, itemKey, exception)
	}
}

export default getItemByItemKey



// WEBPACK FOOTER //
// ./src/dataservices/getItemByItemKey/internal.js